import mixins from '@synergycms_core/less/mixins.js';

export default {
    relativeFoldContainer: {},
    btnTitle: {},
    noPadding: {},
    noMargin: {},
    up: {},
    down: {},
    toggleIcon: {
        font: data => '13px/1px ' + data.fontFamily1,
        color: data => data.mainColor,
        display: 'block',
        transition: 'all .2s ease',
        rotate: '180deg',
    },
    dropDownEnter: {
        transition: 'opacity 0ms ease-out',
        opacity: '0'
    },
    dropDownEnterActive: {
        transition: 'opacity 800ms ease-out',
        opacity: '1',
    },
    dropDownLeave: {
        transition: 'opacity 800ms ease-out',
        opacity: '1',
    },
    dropDownLeaveActive: {
        transition: 'opacity 800ms ease-out',
        opacity: '0',
    },
    dropDownContainer: {
        color: '#000',
        paddingTop: '12px',
        position: 'relative',
        display: 'block',
        overflow: 'visible',
        transition: 'all 0.3s ease',
    },
    dropDownOverflow: {
        width: '100%',
        paddingBottom: '4px',
        paddingTop: '4px',
        borderTop: '1px solid #d8d8d8',
        borderBottom: '1px solid #d8d8d8',
        background: '#fff',
        boxSizing: 'border-box',
        position: 'relative',
        '@media (min-width:801px)': {
            width: 'calc(100% + 454px)',
        },
    },
    defaultStyle: {
        position: 'relative',
        display: 'inline-block',
        '& $relativeFoldContainer': {
            '& $btnToggle': {
                right: '0',
                cursor: 'pointer',
            },
        }
    },
    btnText: {},
    btnToggle: {
        '& $btnText': {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            font: '12px Roboto, sans-serif',
            color: data => data.mainColor,
            marginTop: '1px',
        },
        '&$down': {
            '& $toggleIcon': {
                rotate: '0deg'
            },
        },
        '&:lang(ar)': {
            left: '10px',
            right: 'auto'
        },
    },
    borderBottom: {
        borderBottom: '1px solid #d8d8d8',
        paddingBottom: '4px'
    },
    tooltipBenefitText: data => ({
        '& > ul': {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            overflow: 'auto',
            flexDirection: 'row',
            font: '400 12px / 24px Roboto, sans-serif',
            padding: '0 0 0 16px',
            [`@media (min-width: ${data.modalBreak}px)`]: {
                flexDirection: 'row',
            },
            '& li': {
                margin: '0',
                flexBasis: '100%',
                listStyleType: 'disc',
                listStylePosition: 'outside',
                '&::marker':{
                    color: data.mainColor,
                },
                [`@media (min-width: ${data.modalBreak}px)`]: {
                    flexBasis: '47%'
                },
            },
        },
        '& p':{
            font: '400 12px / 24px Roboto, sans-serif',
            '&:first-of-type':{
                margin: '10px 0 0 0',
            },
            margin: '0 0 10px 0',
        }
    }),
    open: {},
    close: {},
    dropDownWrapper: {
        height: 0,
        overflow: 'hidden',
        position: 'relative',
        transition: 'height 280ms ease',
    },
};